import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IPointsOfferViewRating } from '@/shared/model/points-offer-view-rating.model';

const baseApiUrl = 'api/points-offer-view-ratings';
const baseSearchApiUrl = 'api/_search/points-offer-view-ratings?query=';

export default class PointsOfferViewRatingService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IPointsOfferViewRating> {
    return new Promise<IPointsOfferViewRating>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IPointsOfferViewRating): Promise<IPointsOfferViewRating> {
    return new Promise<IPointsOfferViewRating>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IPointsOfferViewRating): Promise<IPointsOfferViewRating> {
    return new Promise<IPointsOfferViewRating>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
